import type { ReactNode } from "react"

import { StatusStripe } from "../ui/status-stripe"
import styles from "./service-stripes.module.css"

/**
 * Три служебные полосы состояния.
 *
 * ПОЛОСА ГОВОРИТ О СОСТОЯНИИ СЕЙЧАС, а центр уведомлений — о том, что ПРОИЗОШЛО.
 * Одно и то же не сообщается дважды: «нет связи» это полоса и только полоса.
 *
 * ПОРЯДОК СВЕРХУ ВНИЗ ФИКСИРОВАН и задаётся здесь, а не вызывающим кодом:
 * 1. «Нет связи» — самая важная: пока её видно, всё остальное на экране может врать.
 * 2. «Режим поддержки» — скрывать нельзя, режим пишется в журнал и предъявляется салону.
 * 3. «Оплата просрочена» — самая тихая, запись она не блокирует.
 *
 * ВИД ОДНОЙ ПОЛОСЫ ЗДЕСЬ НЕ ЖИВЁТ. Его держит StatusStripe из библиотеки элементов —
 * вместе с поведением на 360, где макет мастера снимает фиксированную высоту и разрешает
 * тексту переноситься. Здесь остаётся ровно то, чего библиотека знать не может: какие
 * полосы сейчас нужны, в каком порядке они стоят и сколько места им можно отдать.
 */

export type StripeKind = "offline" | "impersonate" | "billing"

export interface ServiceStripe {
  readonly kind: StripeKind
  readonly title: string
  readonly text: string
  readonly action: { readonly label: string; readonly onClick: () => void } | null
}

const ORDER: readonly StripeKind[] = ["offline", "impersonate", "billing"]

export function ServiceStripes(props: { readonly stripes: readonly ServiceStripe[] }): ReactNode {
  const ordered = ORDER.flatMap((kind) => props.stripes.filter((stripe) => stripe.kind === kind))
  if (ordered.length === 0) return null

  return (
    <div className={styles.stripes}>
      {ordered.map((stripe) => (
        <StatusStripe
          key={stripe.kind}
          tone={stripe.kind}
          title={stripe.title}
          text={stripe.text}
          action={stripe.action ?? undefined}
        />
      ))}
    </div>
  )
}
